import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchCommitteeNames, fetchCommitteeHistory } from '../../../services/admin/committee-service';
import { doFetch } from '../../../services/fetch/fetch.actions';
import History from './history';

class CommitteeHistory extends Component {
  loadCommittees = () => (dispatch) => {
    dispatch(doFetch(
      'COMMITTEES_NAME',
      fetchCommitteeNames()
        .then((res) => {
          if (!res.ok) {
            throw res.statusText;
          }
          return res.json();
        }),
    ));
  }

  componentDidMount = () => {
    const { committeesName: { fetched, fetching }, dispatch } = this.props;
    if (!fetched && !fetching) {
      dispatch(this.loadCommittees());
    }
  }

  search = (id, from, to) => {
    const { dispatch } = this.props;
    dispatch(doFetch('HISTORY_COMMITTEE', fetchCommitteeHistory(
      id,
      `${from.getFullYear()}.${from.getMonth() + 1}.${from.getDate()}`,
      `${to.getFullYear()}.${to.getMonth() + 1}.${to.getDate()}`,
    ).then((res) => {
      if (!res.ok) throw res.statusText;
      return res.json();
    }), {
      id, from, to,
    }));
  }

  render() {
    const {
      committeesName: {
        payload: { Resources: committees },
        fetched,
      },
      historyCommittee,
    } = this.props;
    return (
      <History
        names={committees}
        namesFetched={fetched}
        history={{ ...historyCommittee, payload: historyCommittee.payload || [] }}
        search={(id, from, to) => this.search(id, from, to)}
      />
    );
  }
}

CommitteeHistory.propTypes = {
  committeesName: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  historyCommittee: PropTypes.object.isRequired,
};

const mapStateToProps = ({
  committeesName, historyCommittee,
}) => ({ committeesName, historyCommittee });

export default connect(mapStateToProps)(CommitteeHistory);
